export default __webpack_public_path__ + "static/media/dog_white_icon.eab6cdb1.svg";